import React, { FC, useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as PersonSVG } from "go-core/images/svg/person.svg";
import { CustomerApi, OrganizationMeApi } from "../../../../../../../../services/Api/types";
import InvoiceDetailsForm from "../../../../../../components/InvoiceDetails/InvoiceDetailsForm";

interface Props {
	meDetails: OrganizationMeApi;
	onFetchOrganizationMeDetails?: (data: OrganizationMeApi) => void;
	customer: CustomerApi | undefined;
}

const SubscriptionsInvoiceDetails: FC<Props> = ({ meDetails, onFetchOrganizationMeDetails, customer }) => {
	const { address, company_name, tax_id_no } = meDetails;
	const [showInvoiceDetailsModal, setShowInvoiceDetailsModal] = useState<boolean>(false);
	const { t } = useTranslation();

	const drawContent = () => {
		if (!address?.city || !address?.street || !company_name || !tax_id_no)
			return (
				<>
					<h5>{t("modules.subscription.field.invoice_details_warning.title")}</h5>
					<h5 className="text-danger font-weight-normal mb-0">
						{t("modules.subscription.field.invoice_details_warning.description")}
					</h5>
					{customer && <p className="text-muted">CustomerId: {customer.external_id}</p>}
				</>
			);
		return (
			<>
				<h5>{company_name}</h5>
				<p className="text-muted mb-0">NIP: {tax_id_no}</p>
				{customer && <p className="text-muted">CustomerId: {customer.external_id}</p>}
			</>
		);
	};

	const getButtonTitle = () => {
		if (!address?.city || !address?.street || !company_name || !tax_id_no) return t("lib:common.action.set");
		return t("modules.subscription.action.change.title");
	};

	return (
		<>
			<Card className={"subscription-info-card"}>
				<Card.Body>
					<div className="d-flex align-items-center">
						<div className="subscription-card-icon-box me-2">
							<PersonSVG className="person-icon" />
						</div>
						<h5 className="mb-0">{t("modules.subscription.field.invoice_details.title")}</h5>
					</div>
					<div className="mt-3">{drawContent()}</div>
					<div className={"card-body-footer"}>
						<a href={"#"} role={"button"} onClick={() => setShowInvoiceDetailsModal(true)}>
							{getButtonTitle()}
						</a>
					</div>
				</Card.Body>
			</Card>
			{showInvoiceDetailsModal && (
				<InvoiceDetailsForm
					details={meDetails}
					isModalForm
					onHideModal={(value?: boolean) => setShowInvoiceDetailsModal(!!value)}
					isModalShown={showInvoiceDetailsModal}
					onFetchOrganizationMeDetails={onFetchOrganizationMeDetails}
				/>
			)}
		</>
	);
};
export default SubscriptionsInvoiceDetails;
